<script>
  import AttributeDropdown from "./attributeDropdown.svelte"

  /**
   * @type {Object} Represents the parsed JSON data.
   */
  export let parsedJson

  /**
   * @type {Boolean} Set attribute button initially disabled state
   */
  export let disableAttributeButton
  /**
   * @type {String} the default or active value in the dropdown area
   */
  let activeItem

  let tempJson
</script>

<div class="grid w-full grid-cols-1 gap-2 p-2">
  <AttributeDropdown bind:disableAttributeButton dropdownItems={Object.keys(parsedJson)} {parsedJson} {activeItem} bind:tempJson />
</div>
